"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoginInfo = exports.setToken = exports.GET_LOGIN_INFO = exports.SET_TOKEN = void 0;
exports.SET_TOKEN = "login/setToken";
exports.GET_LOGIN_INFO = "login/getLoginInfo";
var setToken = function (token) { return ({
    type: exports.SET_TOKEN,
    error: false,
    payload: { token: token },
}); };
exports.setToken = setToken;
var getLoginInfo = function (loginInfo) { return ({
    type: exports.GET_LOGIN_INFO,
    error: false,
    payload: { loginInfo: loginInfo },
}); };
exports.getLoginInfo = getLoginInfo;
